import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const TransazioniConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/transazioni/:contabilita/add',
      component: FuseLoadable({
        loader: () => import('./AddTransazione')
      })
    },
    {
      path: '/transazioni/:contabilita/:id?',
      component: FuseLoadable({
        loader: () => import('./Transazioni')
      })
    }
  ]
}
